import { render } from "./SidebarDashboard.vue?vue&type=template&id=4391b766&scoped=true"
import script from "./SidebarDashboard.vue?vue&type=script&lang=js"
export * from "./SidebarDashboard.vue?vue&type=script&lang=js"

import "./SidebarDashboard.vue?vue&type=style&index=0&id=4391b766&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4391b766"]])

export default __exports__